import { useQuery } from '@tanstack/react-query'
import { ClientOffersService } from '../services'
import { APIOffersClientDtoResponse } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientSearchPackageOffers = (locationName: string) => {
  return useQuery<APIOffersClientDtoResponse>({
    queryKey: ['clientSearchPackageOffers', locationName],
    queryFn: () =>
      ClientOffersService.searchOffers(locationName, {
        type: 'VOUCHER_OFFER',
        includes: ['serviceOffers.service', 'prices', 'locationSpecies.species', 'assetUsages.asset'],
      }),
    ...defaultQueryOptions,
  })
}
